import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Link from '@/src/shared/components/Link';
import { bp, colors } from '@/styles';

const style = {
  nav: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media ${bp.md} {
      flex-direction: row;
    }
  `,
  link: css`
    @media ${bp.md} {
      &::after {
        content: '|';
        padding: 0 5px;
        color: ${colors.accentGrayMedium};
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  `,
  linkActive: css`
    color: ${colors.primaryRed};
  `,
};

const CommitteesNav = memo(function CommitteesNav(props) {
  const {
    router: { route },
  } = props;

  function renderLink(path, title) {
    const styles = [style.link];
    if (path === route) styles.push(style.linkActive);
    return (
      <Link css={styles} href={path}>
        {title}
      </Link>
    );
  }

  return (
    <nav css={style.nav}>
      {renderLink('/policy/committees', 'Overview')}
      {renderLink('/policy/committees/committees-subcommittees', 'Committees and Subcommittees')}
      {renderLink('/policy/committees/working-groups', 'Working Groups')}
      {renderLink('/policy/committees/advisory-lists', 'Advisory Lists')}
    </nav>
  );
});

CommitteesNav.propTypes = {
  router: PropTypes.object.isRequired,
};

export default CommitteesNav;
